.content {
  z-index: 100;
  background: var(--color-grey-25);
  display: block;
  transition-property: none;
  box-shadow: none;
  outline: none;
  overflow: hidden;
  font-size: 1.3rem;
  line-height: 2.1rem;
  text-align: center;
  border-radius: 1.2rem;
  border: thin solid var(--color-neutral);
  padding: 1.2rem 1.7rem;
}

.contentPlain {
  padding: 0;
  font-size: inherit;
  line-height: inherit;
  text-align: inherit;
}
